module.exports = __webpack_public_path__ + "assets/webgl/LM_2_2.jpg.598110a5.webp";